import firebase from "firebase/app";

export const MAX_DURATION_SEC_LIMIT = 180;
export const heartRateAlertSettingCollectionKey = "heartRateAlertSettings";

export type HeartRateAlertSetting = {
  ref: firebase.firestore.DocumentReference;
  data: HeartRateAlertSettingData;
};

export type HeartRateAlertLabel = "low" | "medium" | "high" | "critical";

export type HeartRateAlertLevel = {
  label: HeartRateAlertLabel;
  severity: number;
  minimumDurationSec: number;
};

export type HeartRateAlertSettingData = {
  title: string;
  targetStudentRefs: firebase.firestore.DocumentReference[];
  targetStudentCount: number; //クエリ用
  threshold: number;
  alertLevels: HeartRateAlertLevel[];
  createdAt: number;
  createdBy: string;
};

export function convertToHeartRateAlertSetting(
  data: firebase.firestore.DocumentData,
  ref: firebase.firestore.DocumentReference
): HeartRateAlertSetting {
  const _data: HeartRateAlertSettingData = {
    title: data.title,
    targetStudentRefs: data.targetStudentRefs,
    targetStudentCount: data.targetStudentCount,
    threshold: data.threshold,
    alertLevels: data.alertLevels,
    createdAt: data.createdAt,
    createdBy: data.createdBy
  };

  return {
    ref,
    data: _data
  };
}
